/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from "@fluentui/react-components";

import type { AppContextualMenuProps } from "@1js/acui-menu";

import type {
  AppFlyoutAnchorSlots,
  AppFlyoutAnchorState,
} from "./AppFlyoutAnchor.types";
import { MenuContextProviders } from "./MenuContextProviders";

export const renderAppFlyoutAnchor = (state: AppFlyoutAnchorState) => {
  assertSlots<AppFlyoutAnchorSlots>(state);
  const {
    shadowRenderMenu,
    isShadowRendering,
    persistMenu,
    menuAnchorContextValue,
  } = state;

  // VSO:5851658 see if we can remove the cast for menu, typescript
  // says the union type is too complex
  const shouldRenderMenu =
    !(state.menu as AppContextualMenuProps).hidden ||
    (shadowRenderMenu && isShadowRendering) ||
    persistMenu;

  return (
    <MenuContextProviders
      isShadowRendering={isShadowRendering}
      menuAnchorContextValue={menuAnchorContextValue}
    >
      <>
        <state.menuButton />
        {shouldRenderMenu && <state.menu />}
      </>
    </MenuContextProviders>
  );
};
